import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container py-3" }
const _hoisted_2 = { class: "mb-0 text-primary text-spacing-5 py-1" }
const _hoisted_3 = { class: "mb-0 text-secondary text-spacing-5 py-1" }
const _hoisted_4 = { class: "card border-0 rounded-lg shadow-sm mb-4" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "pb-2 border-bottom border-bottom-dashed" }
const _hoisted_8 = { class: "row gx-2 align-items-center" }
const _hoisted_9 = { class: "col-auto" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "fs-4 fw-bolder text-primary" }
const _hoisted_12 = { class: "py-2 border-bottom border-bottom-dashed" }
const _hoisted_13 = { class: "row gx-2 align-items-center" }
const _hoisted_14 = { class: "col-auto" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "fs-4 fw-bolder text-primary" }
const _hoisted_17 = { class: "py-2 border-bottom border-bottom-dashed" }
const _hoisted_18 = { class: "row gx-2 align-items-center" }
const _hoisted_19 = { class: "col-auto" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "fs-4 fw-bolder text-primary" }
const _hoisted_22 = { class: "py-2" }
const _hoisted_23 = { class: "row gx-2 align-items-stretch" }
const _hoisted_24 = { class: "col-auto py-2" }
const _hoisted_25 = { class: "row g-1 flex-column justify-content-center h-100" }
const _hoisted_26 = {
  class: "col-auto",
  style: {"line-height":"1em"}
}
const _hoisted_27 = {
  class: "col",
  style: {"line-height":"1em"}
}
const _hoisted_28 = { class: "col" }
const _hoisted_29 = { class: "py-2 border-bottom border-bottom-dashed" }
const _hoisted_30 = { class: "mb-0 fs-5" }
const _hoisted_31 = {
  key: 0,
  class: "rounded bg-primary-light px-2 py-1"
}
const _hoisted_32 = { class: "py-2" }
const _hoisted_33 = { class: "mb-0 fs-5" }
const _hoisted_34 = {
  key: 0,
  class: "rounded bg-primary-light px-2 py-1"
}
const _hoisted_35 = { class: "card border-0 rounded-lg shadow-sm mb-4" }
const _hoisted_36 = { class: "card-body" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "row g-0 border-bottom border-bottom-dashed" }
const _hoisted_39 = { class: "col" }
const _hoisted_40 = { class: "pb-1 border-bottom border-bottom-dashed" }
const _hoisted_41 = { class: "row gx-2 align-items-center" }
const _hoisted_42 = { class: "col-auto" }
const _hoisted_43 = ["title"]
const _hoisted_44 = { class: "py-1 border-bottom border-bottom-dashed" }
const _hoisted_45 = { class: "row gx-2 align-items-center" }
const _hoisted_46 = { class: "col-auto" }
const _hoisted_47 = ["title"]
const _hoisted_48 = { class: "py-1 border-bottom border-bottom-dashed" }
const _hoisted_49 = { class: "row gx-2 align-items-center" }
const _hoisted_50 = { class: "col-auto" }
const _hoisted_51 = ["title"]
const _hoisted_52 = { class: "py-1" }
const _hoisted_53 = { class: "row gx-2 align-items-center" }
const _hoisted_54 = { class: "col-auto" }
const _hoisted_55 = { class: "fs-3 text-primary" }
const _hoisted_56 = {
  key: 0,
  class: "col-auto ps-4 pe-2"
}
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "py-1 border-bottom border-bottom-dashed" }
const _hoisted_59 = { class: "row gx-2 align-items-center text-center" }
const _hoisted_60 = { class: "col" }
const _hoisted_61 = { class: "fs-2 text-primary fw-bolder" }
const _hoisted_62 = { class: "col" }
const _hoisted_63 = { class: "fs-2 text-danger" }
const _hoisted_64 = { class: "col" }
const _hoisted_65 = { class: "fs-2 text-primary fw-bolder" }
const _hoisted_66 = { class: "py-1 border-bottom border-bottom-dashed" }
const _hoisted_67 = { class: "row gx-2 align-items-center" }
const _hoisted_68 = { class: "col" }
const _hoisted_69 = { class: "py-2 mb-3" }
const _hoisted_70 = { class: "fs-5" }
const _hoisted_71 = { class: "card border-0 rounded-lg shadow-sm" }
const _hoisted_72 = { class: "card-footer border-0 p-0 overflow-hidden rounded-bottom-lg" }
const _hoisted_73 = {
  id: "trace-map",
  ref: "traceMap",
  class: "map"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AlertMessage = _resolveComponent("AlertMessage")!
  const _component_Rating = _resolveComponent("Rating")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.detailData && _ctx.detailData.IsComplete)
      ? (_openBlock(), _createBlock(_component_AlertMessage, {
          key: 0,
          variant: "primary"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_2, [
              _createVNode(_component_Icon, {
                icon: _ctx.CompleteChecked,
                width: "1.2em",
                height: "1.2em",
                class: "me-2"
              }, null, 8, ["icon"]),
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mb-0 align-middle fw-bolder" }, "服務已完成", -1))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.detailData && _ctx.detailData.IsCancel)
      ? (_openBlock(), _createBlock(_component_AlertMessage, {
          key: 1,
          variant: "secondary"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h4", _hoisted_3, [
              _createVNode(_component_Icon, {
                icon: _ctx.CompleteChecked,
                width: "1.2em",
                height: "1.2em",
                class: "me-2"
              }, null, 8, ["icon"]),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mb-0 align-middle fw-bolder" }, "服務已取消", -1))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "card-header border-0 bg-primary-light text-center rounded-top-lg" }, [
        _createElementVNode("span", { class: "text-spacing-5 text-primary fw-bolder" }, "任務需求")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.detailData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Icon, {
                      icon: _ctx.Time,
                      width: "1.2em",
                      height: "1.2em",
                      class: "text-primary"
                    }, null, 8, ["icon"])
                  ]),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-auto" }, [
                    _createElementVNode("span", { class: "small text-spacing-4 fw-bolder text-label-color" }, "預約時間")
                  ], -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.OrderTimeFormat(_ctx.detailData.OrderTime)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Icon, {
                      icon: _ctx.BoyFace,
                      width: "1.2em",
                      height: "1.2em",
                      class: "text-primary"
                    }, null, 8, ["icon"])
                  ]),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-auto" }, [
                    _createElementVNode("span", { class: "small text-spacing-4 fw-bolder text-label-color" }, "乘客姓名")
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.detailData.Passenger?.Name), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_Icon, {
                      icon: _ctx.PhoneRounded,
                      width: "1.2em",
                      height: "1.2em",
                      class: "text-primary"
                    }, null, 8, ["icon"])
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "col-auto" }, [
                    _createElementVNode("span", { class: "small text-spacing-4 fw-bolder text-label-color" }, "聯絡電話")
                  ], -1)),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.detailData.Passenger?.PhoneNumber), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createVNode(_component_Icon, {
                          icon: _ctx.Circle,
                          width: "1.2em",
                          height: "1.2em",
                          class: "text-primary"
                        }, null, 8, ["icon"])
                      ]),
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col" }, [
                        _createElementVNode("div", {
                          class: "bg-primary h-100 mx-auto",
                          style: {"width":"3px","border-radius":"1px"}
                        })
                      ], -1)),
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_Icon, {
                          icon: _ctx.LocationFilled,
                          width: "1.2em",
                          height: "1.2em",
                          class: "text-primary"
                        }, null, 8, ["icon"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "small text-spacing-4 fw-bolder text-label-color" }, " 搭車地點 | 上車地點備註 ", -1)),
                      _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.detailData.StartAddress), 1),
                      (_ctx.detailData.AdditionMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.detailData.AdditionMessage), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "small text-spacing-4 fw-bolder text-label-color" }, " 搭車地點 | 上車地點備註 ", -1)),
                      _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.detailData.TargetAddress), 1),
                      (_ctx.detailData.TargetAdditionMessage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(_ctx.detailData.TargetAdditionMessage), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "card-header border-0 bg-primary-light text-center rounded-top-lg" }, [
        _createElementVNode("span", { class: "text-spacing-5 text-primary fw-bolder" }, "服務紀錄")
      ], -1)),
      _createElementVNode("div", _hoisted_36, [
        (_ctx.detailData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col" }, [
                        _createElementVNode("span", { class: "small text-spacing-4 fw-bolder text-label-color" }, "到達時間")
                      ], -1)),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("span", {
                          class: "fs-3 text-primary",
                          title: _ctx.detailData.ArrivalTime?.toString()
                        }, _toDisplayString(_ctx.ValueOrDash(_ctx.ProcessTimeFormat(_ctx.detailData.ArrivalTime))), 9, _hoisted_43)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col" }, [
                        _createElementVNode("span", { class: "small text-spacing-4 fw-bolder text-label-color" }, "開始搭乘")
                      ], -1)),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("span", {
                          class: "fs-3 text-primary",
                          title: _ctx.detailData.GetonTime?.toString()
                        }, _toDisplayString(_ctx.ValueOrDash(_ctx.ProcessTimeFormat(_ctx.detailData.GetonTime))), 9, _hoisted_47)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col" }, [
                        _createElementVNode("span", { class: "small text-spacing-4 fw-bolder text-label-color" }, "下車時間")
                      ], -1)),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("span", {
                          class: "fs-3 text-primary",
                          title: _ctx.detailData.GetoffTime?.toString()
                        }, _toDisplayString(_ctx.ValueOrDash(_ctx.ProcessTimeFormat(_ctx.detailData.GetoffTime))), 9, _hoisted_51)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col" }, [
                        _createElementVNode("span", { class: "small text-spacing-4 fw-bolder text-label-color" }, "乘車時間")
                      ], -1)),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.ValueOrDash(
                        _ctx.SecondToMinuteFormat(_ctx.detailData.TravelTime ?? 0),
                      )), 1),
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "small text-spacing-4 fw-bolder text-label-color" }, "分鐘", -1))
                      ])
                    ])
                  ])
                ]),
                (_ctx.detailData.PickupPictureUrl || !_ctx.hidePickupPicture)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                      _createElementVNode("img", {
                        class: "rounded",
                        src: _ctx.ImageUrlFormat(_ctx.detailData.PickupPictureUrl),
                        width: "114",
                        onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.OnPickupPictureError && _ctx.OnPickupPictureError(...args)))
                      }, null, 40, _hoisted_57)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "small text-spacing-4 fw-bolder text-label-color" }, "跳表金額", -1)),
                    _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.ValueOrDash(_ctx.detailData.MeterAmount)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "small text-spacing-4 fw-bolder text-label-color" }, "使用優惠卷", -1)),
                    _createElementVNode("div", _hoisted_63, [
                      _createElementVNode("span", {
                        class: _normalizeClass({
                      'text-negative-number': _ctx.detailData.BounsAmount < 0,
                      'fw-bolder': true,
                    })
                      }, _toDisplayString(_ctx.detailData.BounsAmount == null
                        ? _ctx.ValueOrDash()
                        : Math.abs(_ctx.detailData.BounsAmount)), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "small text-spacing-4 fw-bolder text-label-color" }, "實收金額", -1)),
                    _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.ValueOrDash(_ctx.detailData.ActualAmount)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "col-auto" }, [
                    _createElementVNode("span", { class: "small text-spacing-4 fw-bolder text-label-color" }, "乘客評價")
                  ], -1)),
                  _createElementVNode("div", _hoisted_68, [
                    _createVNode(_component_Rating, {
                      value: _ctx.detailData.PassengerRatingDriver
                    }, null, 8, ["value"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_69, [
                _cache[19] || (_cache[19] = _createElementVNode("div", { class: "small text-spacing-4 fw-bolder text-label-color mb-2" }, "備註", -1)),
                _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.detailData.PassengerRatingRemark), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_71, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "card-header border-0 bg-primary-light text-center rounded-top-lg" }, [
        _createElementVNode("span", { class: "text-spacing-5 text-primary fw-bolder" }, "軌跡紀錄")
      ], -1)),
      _createElementVNode("div", _hoisted_72, [
        _createElementVNode("div", _hoisted_73, null, 512)
      ])
    ])
  ]))
}